import react from 'react'
import { userStore, UserState } from '../api/AuthService';
import { DriverProfile } from '../api/model/DriverProfile';

export const NewDriverPacketModule = (props: { ownerData?: any, unitData?: any, intials?: any, mf?: any, cdlNumber?: any, ssn?: any, yearsExperience?: any, emergencyContactName1?: any, emergencyContactPhone1?: any, emergencyContactName2?: any, emergencyContactPhone2?: any, viewObject?: any, signatureData?: any, date?: any, year?: any}) => {

  const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));

  function convertDOYtoSQL(yyyyddd: any) {
    const year = parseInt(yyyyddd.substring(0, 4), 10);
    const dayOfYear = parseInt(yyyyddd.substring(4), 10);
    const date = new Date(year, 0, dayOfYear);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

  return <div>
  <title>New Driver Packet 2024</title>
  <style
    type="text/css"
    dangerouslySetInnerHTML={{
      __html:
        ' * {margin:0; padding:0; text-indent:0; }\n .s1 { color: #282828; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s4 { color: #282828; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s5 { color: #282828; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10.5pt; }\n .s6 { color: #282828; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11.5pt; }\n .s7 { color: #282828; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 11pt; }\n .s8 { color: #282828; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12.5pt; }\n .s9 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n h1 { color: #808080; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 24pt; }\n .s10 { color: #3C3C3C; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s11 { color: #808080; font-family:"Franklin Gothic Medium Cond", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 14pt; }\n .s12 { color: #808080; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 14pt; }\n .s13 { color: #A6A6A6; font-family:Calibri, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 8pt; }\n h2 { color: #464343; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 18pt; }\n .s14 { color: #464343; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12.5pt; }\n .p, p { color: #414042; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9pt; margin:0pt; }\n .s15 { color: #414042; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s16 { color: #414042; font-family:Calibri, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s17 { color: #000; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s18 { color: #414042; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s19 { color: black; font-family:"Calibri Light", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s20 { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s21 { color: #414042; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s22 { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s23 { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s24 { color: #000; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9pt; }\n .s25 { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9pt; }\n .s26 { color: black; font-family:"Calibri Light", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9pt; }\n .s27 { color: #3D3D3D; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; }\n .s29 { color: #414042; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9pt; }\n .s30 { color: #3D3D3D; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 9pt; }\n .s32 { color: #A6A6A6; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 8pt; }\n .s33 { color: #000; font-family:"Franklin Gothic Medium", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .a { color: #414042; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s35 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 13.5pt; }\n .s36 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9.5pt; }\n .s37 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n .s38 { color: #201E1F; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n .s39 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 13.5pt; }\n .s41 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n .s42 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 9.5pt; }\n .s43 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n .s44 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9.5pt; }\n .s46 { color: #000; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12.5pt; }\n .s47 { color: #000; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .s48 { color: black; font-family:"Gill Sans MT", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 14pt; }\n .s49 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9pt; }\n .s50 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s51 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 14pt; }\n .s52 { color: #464343; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s54 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 20.5pt; }\n .s55 { color: #464343; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s56 { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s57 { color: #000; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s58 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 7pt; }\n .s59 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 7pt; }\n .s60 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 24pt; }\n .s61 { color: black; font-family:"Trebuchet MS", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 14pt; }\n .s62 { color: black; font-family:"Lucida Sans Unicode", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6pt; vertical-align: 1pt; }\n .s63 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 8pt; }\n .s65 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 8pt; }\n .s66 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9pt; }\n .s67 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 8pt; }\n .s68 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 7pt; }\n .s69 { color: black; font-family:"Lucida Sans Unicode", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 5pt; vertical-align: 1pt; }\n .s70 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 5pt; }\n .s71 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s72 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 8pt; }\n .s73 { color: #000; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s74 { color: #000; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s75 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 14pt; }\n .s76 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 8pt; }\n .s77 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .s78 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 7pt; vertical-align: 1pt; }\n .s79 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; vertical-align: 1pt; }\n .s80 { color: #505050; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 18pt; }\n .s81 { color: #505050; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11.5pt; }\n .s82 { color: #2E2E2E; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 15pt; }\n .s83 { color: #2E2E2E; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 15.5pt; }\n .s84 { color: #2E2E2E; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12.5pt; }\n .s85 { color: #2E2E2E; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 15.5pt; }\n .s86 { color: #2E2E2E; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 14pt; }\n li {display: block; }\n #l1 {padding-left: 0pt; }\n #l1> li>*:first-child:before {content: "• "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; }\n #l2 {padding-left: 0pt; }\n #l2> li>*:first-child:before {content: "o "; color: #414042; font-family:"Courier New", monospace; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9pt; }\n li {display: block; }\n #l3 {padding-left: 0pt; }\n #l3> li>*:first-child:before {content: "• "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9pt; }\n li {display: block; }\n #l4 {padding-left: 0pt; }\n #l4> li>*:first-child:before {content: " "; color: #414042; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n li {display: block; }\n #l5 {padding-left: 0pt;counter-reset: f1 2; }\n #l5> li>*:first-child:before {counter-increment: f1; content: counter(f1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n li {display: block; }\n #l6 {padding-left: 0pt;counter-reset: f1 2; }\n #l6> li>*:first-child:before {counter-increment: f1; content: counter(f1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n #l7 {padding-left: 0pt;counter-reset: f2 1; }\n #l7> li>*:first-child:before {counter-increment: f2; content: counter(f2, decimal)" "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 7pt; }\n #l7> li:first-child>*:first-child:before {counter-increment: f2 0;  }\n li {display: block; }\n #l8 {padding-left: 0pt;counter-reset: g1 1; }\n #l8> li>*:first-child:before {counter-increment: g1; content: counter(g1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 8pt; }\n #l8> li:first-child>*:first-child:before {counter-increment: g1 0;  }\n li {display: block; }\n #l9 {padding-left: 0pt; }\n #l9> li>*:first-child:before {content: "• "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 8pt; }\n table, tbody {vertical-align: top; overflow: visible; }\n'
    }}
  />
  <p
    className="s1"
    style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "center" }}
  >
    <a>‌</a>Independent Contractor Insurance Requirement
    Addendum
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "15pt", textIndent: "0pt", textAlign: "justify" }}
  >
    I,
    <u>
    {props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name22}
    </u>
    <span style={{ color: "#424242" }}>, </span>("Contractor") understand that I
    have entered into a Contract Hauling Agreement as an independent contractor
    doing business with Western Express. As an independent contractor, I am
    required to provide proof of insurance. My Contract Hauling Agreement with
    Western Express outlines minimal coverage requirements regarding liability,
    cargo, and non-trucking liability coverage. Additionally,{" "}
    <span className="s4">I </span>am required to provide proof of Worker's
    Compensation coverage. <span className="s4">I </span>am fully aware that{" "}
    <span className="s5">I </span>am not an employee of Western Express,
    therefore <span className="s5">I </span>am not eligible for Worker's
    Compensation benefits from Western Express. <span className="s6">I </span>
    must provide Western Express with proof of Worker's Compensation or similar
    coverage for myself and my employees.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "15pt", textIndent: "0pt", textAlign: "justify" }}
  >
    <span className="s7">
    <u>{props.viewObject !== undefined ? props.viewObject.driverIntials1 : props.intials}&nbsp;</u>
    </span>
    <span className="s4">I </span>have elected to procure insurance through a
    vendor provided by Western Express. <span className="s4">I </span>
    acknowledge that said coverage shall satisfy the minimum requirements listed{" "}
    <span className="s6">in </span>my Contract Hauling Agreement with Western
    Express. <span className="s6">I </span>have been provided with a copy of my
    Contract Hauling Agreement, insurance certificate, and insurance infonnation
    brochure. <span className="s5">I </span>understand that{" "}
    <span className="s5">I </span>may elect to cancel my coverage and procure
    insurance through any vendor of my choice at any time.{" "}
    <span className="s6">I </span>also agree that policy standards, policies,
    premiums, or deductibles are subject to change.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "15pt", textIndent: "40pt", textAlign: "justify" }}
  >
    <span className="s5">I </span>have elected to deny coverage from the vendor
    provided for me by Western Express. <span className="s5">I </span>
    acknowledge the minimum insurance coverage outlined in my Contract Hauling
    Agreement. I will provide Western Express with a copy an insurance
    certificate indicating that the minimum coverage has been satisfied, and I
    have voluntarily authorized Western Express to be acknowledged as an
    additionally insured party and Certificate Holder on my policy.{" "}
    <span className="s8">In </span>the event of cancellation or modification of
    any policy, wiitten notice shall be given to Western Express at least thirty
    (30) days prior to the effective date of such cancellation or modification.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "15pt", textIndent: "0pt", textAlign: "justify" }}
  >
    As an independent contractor <span className="s6">I </span>have the right to
    make all decisions relating to my business, including the vendor providing
    my insurance coverage. <span className="s6">I </span>agree to maintain, in
    full force, any and all coverage required y my Contract Hauling Agreement
    with Western Express.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "15pt", textIndent: "0pt", textAlign: "justify" }}
  >
    All terms, provisions, and agreements set forth in the Contract Hauling
    Agreement are hereby incorporated herein <span className="s6">by </span>
    reference with the same force and effect as though fully set forth herein.
    To the extent that the terms set forth in this Addendum are inconsistent
    with the terms of the Contract Hauling Agreement, the terms set forth in the
    Contract Hauling Agreement shall apply.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s9"
    style={{ paddingLeft: "44pt", textIndent: "0pt", textAlign: "left" }}
  >
    <span>
      {" "}
      <span />
    </span>
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "15pt", textIndent: "0pt", textAlign: "justify" }}
  >
    Contractor Date Western Express Date
  </p>
  <h1
    style={{
      paddingLeft: "66pt",
      textIndent: "0pt",
      lineHeight: "28pt",
      textAlign: "left"
    }}
  >
    INSURANCE OPTIONS
  </h1>
  <h1 style={{ paddingLeft: "66pt", textIndent: "0pt", textAlign: "left" }}>
    FOR INDEPENDENT CONTRACTOR TRUCKING PROFESSIONALS
  </h1>
  <p
    className="s10"
    style={{
      paddingTop: "16pt",
      paddingLeft: "67pt",
      textIndent: "0pt",
      lineHeight: "114%",
      textAlign: "left"
    }}
  >
    Western Express, Inc. cares about the success of your business. To help you
    succeed, we’ve partnered with Cottingham &amp; Butler for competitive
    settlement deduction insurance offerings. Proper insurance coverage is
    critical to protecting your business as an independent Contractor. Please
    review the information within this guide carefully and consult with your
    Contractor Services Representative at 563.587.5600 with questions.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s11"
    style={{ paddingLeft: "66pt", textIndent: "0pt", textAlign: "left" }}
  >
    COVERAGES OFFERED:
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <p
    className="s12"
    style={{
      paddingTop: "3pt",
      paddingLeft: "66pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Occupational Accident p1
  </p>
  <p
    className="s12"
    style={{
      paddingTop: "2pt",
      paddingLeft: "66pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Non-Trucking Liability p4
  </p>
  <p
    className="s12"
    style={{
      paddingTop: "2pt",
      paddingLeft: "66pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Physical Damage p5
  </p>
  <p
    className="s12"
    style={{
      paddingTop: "2pt",
      paddingLeft: "66pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Deductible Buyback p7
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s13"
    style={{
      paddingLeft: "49pt",
      textIndent: "0pt",
      lineHeight: "113%",
      textAlign: "center"
    }}
  >
    The information described herein is only intended to be a summary of your
    insurance options. It does not describe nor include all benefit provisions,
    limitations, exclusions, or qualifications for coverage. Please review your
    policy for a complete explanation of your benefits. If the benefits conflict
    in any way with the policy, the policy will prevail.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <h2
    style={{
      paddingTop: "13pt",
      paddingLeft: "32pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    OCCUPATIONAL ACCIDENT – GREAT AMERICAN
  </h2>
  <p
    className="s14"
    style={{
      paddingLeft: "32pt",
      textIndent: "0pt",
      lineHeight: "36pt",
      textAlign: "left"
    }}
  >
    Program Pricing &amp; Fees: $119.00 per month What is it?
  </p>
  <p
    style={{
      paddingLeft: "32pt",
      textIndent: "0pt",
      lineHeight: "114%",
      textAlign: "justify"
    }}
  >
    Occupational Accident insurance provides benefits for certain injuries that
    may occur while you are on duty and under dispatch to your motor carrier. To
    be eligible for benefits, the injury must be directly caused by an accident
    and independent of other causes. This insurance does not provide coverage
    for sickness and does not provide statutory Workers’ Compensation coverage.
  </p>
  <p style={{ paddingTop: "8pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s14"
    style={{ paddingLeft: "32pt", textIndent: "0pt", textAlign: "left" }}
  >
    Why buy it?
  </p>
  <ul id="l1">
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        You are a self-employed independent contractor and therefore not covered
        by your motor carrier’s workers compensation policy.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "127%",
          textAlign: "left"
        }}
      >
        Even if you are covered under a health insurance plan, medical expenses
        for injuries sustained by self-employed individuals while at work are
        excluded.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{ paddingLeft: "59pt", textIndent: "-18pt", textAlign: "left" }}
      >
        If you are injured and unable to drive your truck, you need disability
        income to cover your living expenses.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Your contract with your motor carrier may require you to carry work
        injury/accident coverage.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Occupational Accident is the most cost effective form of work injury
        coverage.
      </p>
      <p style={{ paddingTop: "9pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s14"
        style={{ paddingLeft: "32pt", textIndent: "0pt", textAlign: "left" }}
      >
        Who is eligible for coverage?
      </p>
      <p
        className="s15"
        style={{
          paddingTop: "4pt",
          paddingLeft: "32pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Owner Operators
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Between the ages of 23 and 90 who are under contract to this motor
        carrier
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "127%",
          textAlign: "left"
        }}
      >
        owns or leases a power unit (from an entity other than the Policyholder)
        which he or she is operating for the purpose of performing Occupational
        services
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "11pt",
          textAlign: "left"
        }}
      >
        is an independent contractor as defined by law, and
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        is not an employee of the Policyholder
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Owner-Operator includes a Co-Owner, but only if the Co-Owner otherwise
        meets the definition of Owner-Operator
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        The Owner Operator must be someone who has entered into a covered
        contract for leasing of the power unit,
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        has a valid CDL,
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        doesn’t own or control the Policyholder,
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "114%",
          textAlign: "left"
        }}
      >
        and receives a 1099. Co-Owners and Co-Drivers can be included as Owner
        Operators if they meet the definition and have been added as a class of
        risk on the Schedule of Benefits.
      </p>
      <p
        className="s15"
        style={{
          paddingTop: "1pt",
          paddingLeft: "32pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Contract Drivers
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Between the ages of 23 and 90
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        for the purpose of performing Occupational services, drives a power unit
        owned or leased by an Owner-Operator;
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        is on file with the Company;
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        is not an employee of the Policyholder and
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        is not an employee of an Owner-Operator, unless it is not mandatory for
        workers’ compensation coverage to be provided for such person as an
        employee of either the Policyholder or an Owner-Operator
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{ paddingLeft: "59pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Has a valid and current CDL on the effective date of enrollment.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Is compensated by 1099 on a basis other than time expended in the
        performance of work.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "127%",
          textAlign: "justify"
        }}
      >
        Is classified as an independent contractor by the person who has engaged
        his or her services and not as an employee for purposes of workers'
        compensation insurance, federal income taxes, state income taxes, social
        security, unemployment insurance or for any other purpose
      </p>
      <p
        className="s14"
        style={{
          paddingTop: "6pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Coverage Highlights:{" "}
        <span className="s16">
          see your policy for complete benefit limits and exclusions.
        </span>
      </p>
      <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "0pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "18pt" }}>
            <td
              style={{
                width: "149pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "181pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p
                className="s17"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "77pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                OCCUPATIONAL
              </p>
            </td>
            <td
              style={{
                width: "154pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p
                className="s17"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "22pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                NON-OCCUPATIONAL
              </p>
            </td>
          </tr>
          <tr style={{ height: "18pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s18"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Combined Single Limit
              </p>
            </td>
            <td
              style={{
                width: "335pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={2}
            >
              <p
                className="s19"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "30pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                $1,000,000
              </p>
            </td>
          </tr>
          <tr style={{ height: "18pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Aggregate Limit
              </p>
            </td>
            <td
              style={{
                width: "335pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={2}
              color="#F0F0F0"
            >
              <p
                className="s20"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "30pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                $1,000,000
              </p>
            </td>
          </tr>
          <tr style={{ height: "32pt" }}>
            <td
              style={{
                width: "484pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={3}
            >
              <p
                className="s21"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                MEDICAL BENEFITS
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                Provides coverage for medical care that is medically necessary
                due to a covered injury
              </p>
            </td>
          </tr>
          <tr style={{ height: "32pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "43pt",
                  textIndent: "0pt",
                  lineHeight: "16pt",
                  textAlign: "left"
                }}
              >
                Maximum Benefit Maximum Benefit Period
              </p>
            </td>
            <td
              style={{
                width: "181pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                $1,000,000
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                104 weeks
              </p>
            </td>
            <td
              style={{
                width: "154pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "9pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                $10,000
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "9pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                104 weeks
              </p>
            </td>
          </tr>
          <tr style={{ height: "32pt" }}>
            <td
              style={{
                width: "484pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={3}
            >
              <p
                className="s21"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                TEMPORARY TOTAL DISABILITY
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                Provides disability benefits when you are temporarily disabled
                from working due to a covered injury
              </p>
            </td>
          </tr>
          <tr style={{ height: "65pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Weekly Benefit
              </p>
              <p
                style={{
                  paddingTop: "3pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                <br />
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "43pt",
                  textIndent: "0pt",
                  lineHeight: "16pt",
                  textAlign: "left"
                }}
              >
                Waiting Period Maximum Benefit Period
              </p>
            </td>
            <td
              style={{
                width: "181pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  lineHeight: "131%",
                  textAlign: "left"
                }}
              >
                70% Average Weekly Earnings up to $700 MAX / $200 MIN
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                7 Days Retroactive
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                104 weeks
              </p>
            </td>
            <td
              style={{
                width: "154pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "34pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Not Covered
              </p>
            </td>
          </tr>
          <tr style={{ height: "48pt" }}>
            <td
              style={{
                width: "484pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={3}
            >
              <p
                className="s21"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                CONTINUOUS TOTAL DISABILITY
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Provides disability benefits when you are expected to be totally
                disabled for the remainder of your life and
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                have received a Social Security Disability Award due solely to
                the covered injury
              </p>
            </td>
          </tr>
          <tr style={{ height: "48pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  paddingRight: "48pt",
                  textIndent: "0pt",
                  lineHeight: "133%",
                  textAlign: "left"
                }}
              >
                Monthly Benefit Waiting Period
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Maximum Benefit Period
              </p>
            </td>
            <td
              style={{
                width: "181pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  paddingRight: "58pt",
                  textIndent: "0pt",
                  lineHeight: "133%",
                  textAlign: "left"
                }}
              >
                Up to $3,010 MAX 104 weeks
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                To Social Security Retirement Age
              </p>
            </td>
            <td
              style={{
                width: "154pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                style={{
                  paddingTop: "7pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                <br />
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "34pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Not Covered
              </p>
            </td>
          </tr>
          <tr style={{ height: "50pt" }}>
            <td
              style={{
                width: "484pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={3}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s21"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                ACCIDENTAL DEATH, DISMEMBERMENT &amp; PARALYSIS BENEFITS
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Provides benefits for death, dismemberment, or paralysis
                according to the schedule outlined in the policy
              </p>
            </td>
          </tr>
          <tr style={{ height: "48pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Maximum Benefit Amount
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Survivor’s Benefit
              </p>
            </td>
            <td
              style={{
                width: "181pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                $300,000 Principal Sum
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                $50,000 Lump Sum +
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "37pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                $2,500/month up to 100 months
              </p>
            </td>
            <td
              style={{
                width: "154pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "15pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                $10,000 Principal Sum
              </p>
            </td>
          </tr>
          <tr style={{ height: "32pt" }}>
            <td
              style={{
                width: "484pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={3}
            >
              <p
                className="s21"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                KEY ENDORSEMENTS &amp; SUBLIMITS:
              </p>
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                Other exclusions and coverage limitations apply. See policy for
                complete benefit information.
              </p>
            </td>
          </tr>
          <tr style={{ height: "48pt" }}>
            <td
              style={{
                width: "149pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  paddingRight: "94pt",
                  textIndent: "0pt",
                  lineHeight: "130%",
                  textAlign: "left"
                }}
              >
                Hernia Severe Burn
              </p>
            </td>
            <td
              style={{
                width: "181pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s18"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "36pt",
                  paddingRight: "26pt",
                  textIndent: "0pt",
                  lineHeight: "130%",
                  textAlign: "left"
                }}
              >
                Lifetime $20,000 Sublimit Incl. within the Accidental
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "36pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                Dismemberment Principal Sum
              </p>
            </td>
            <td
              style={{
                width: "154pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                style={{
                  paddingTop: "7pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                <br />
              </p>
              <p
                className="s18"
                style={{
                  paddingLeft: "33pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Not Covered
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        className="s14"
        style={{
          paddingTop: "6pt",
          paddingLeft: "32pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Occupational Accident Exclusions
      </p>
      <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s15"
        style={{
          paddingLeft: "32pt",
          textIndent: "0pt",
          lineHeight: "131%",
          textAlign: "left"
        }}
      >
        This Policy does not cover any Injury, Accident, expense, or loss caused
        in whole or in part by, or resulting in whole or in part from, any of
        the following:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "125%",
          textAlign: "left"
        }}
      >
        an Insured Person's suicide or any attempt at suicide; intentionally
        self-inflicted injury or any attempt at intentionally self-inflicted
        injury:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        sickness, disease or infection of any kind, except bacterial infection
        due to a cut or wound, or botulism or ptomaine poisoning, caused
        directly by an Occupational Accident:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        any Pre-Existing Condition, unless the Insured Person has been
        continuously covered under this Policy (or a substantially identical
        policy issued by the Company or another insurer, of which this policy is
        a renewal) for twelve consecutive months:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        Occupational Cumulative Trauma, unless (and then only to the extent
        that) such coverage has been specifically added to this Policy by
        endorsement:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{ paddingLeft: "59pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Occupational Disease, unless (and then only to the extent that) such
        coverage has been specifically added to this Policy by endorsement:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        hernia of any kind, unless (and then only to the extent that) such
        coverage has been specifically added to this Policy by endorsement:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        hemorrhoids of any kind, unless (and then only to the extent that) such
        coverage has been specifically added to this Policy by endorsement:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "justify"
        }}
      >
        performing, learning to perform or instructing others to perform as a
        master or crew member of any vessel while covered under the Jones Act or
        the United States Longshoremen's and Harbor Workers' Compensation Act or
        any amendment of that Act, or any similar state or federal law:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "justify"
        }}
      >
        declared or undeclared war, or any act of declared or undeclared war:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "129%",
          textAlign: "left"
        }}
      >
        full-time active duty in the armed forces of any country or
        international authority, except the National Guard or organized reserve
        corps duty:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "59pt",
          textIndent: "-18pt",
          lineHeight: "11pt",
          textAlign: "left"
        }}
      >
        any Injury for which the Insured Person is entitled to benefits pursuant
        to any workers' compensation law or other similar legislation:
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        employers' liability
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        the Insured Person's being under the influence of any drug or
        intoxicant, unless taken at the direction of his or her Physician: or
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        the Insured Person's commission of, or attempt to commit, a felony: or
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        travel or flight in or on (including getting in or out of, or on or off
        of) any type of aircraft, if the Insured Person is:
      </p>
      <ul id="l2">
        <li data-list-text="o">
          <p
            style={{
              paddingTop: "3pt",
              paddingLeft: "81pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            riding as a passenger in an aircraft not designed and licensed for
            the transportation of passengers: or
          </p>
        </li>
        <li data-list-text="o">
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "81pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            performing, learning to perform or instructing others to perform as
            a pilot or crew member of any aircraft: or
          </p>
        </li>
        <li data-list-text="o">
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "81pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            riding as a passenger in an aircraft owned, leased or operated by
            the Policyholder: or
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        any strike, boycott or stop-work action, whether or not the Insured
        Person participated in such strike, boycott, or stop-work action.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "61pt",
          textIndent: "-20pt",
          textAlign: "left"
        }}
      >
        Participation in a riot, civil disturbance
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Commission or attempt to commit a felon, assault, or other illegal
        activity
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Any Conditions which continues, progresses, develops, or does not
        qualify as an Accident
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Being under the influence of drugs, narcotics
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Being legally intoxicated
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Loss arising out of Terrorism
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Injury, when travelling against medical advice
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Mental &amp; nervous disorders
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Lost income outside of the USA
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Deliberately ingesting poison, chemicals, gas
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Use of explosives, radiation, chemicals, biological agents
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        A stroke or cardio event.
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "61pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Charges for injuries paid by a 3rd party
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Alcoholism, drug addiction
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "59pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Participation in dangerous activities, such as bungee jumping, stunts,
        zip-lining etc.
      </p>
    </li>
  </ul>
  <h2
    style={{
      paddingTop: "13pt",
      paddingLeft: "24pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    NON-TRUCKING LIABILITY – GREAT AMERICAN
  </h2>
  <p
    className="s14"
    style={{
      paddingTop: "20pt",
      paddingLeft: "24pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Program Pricing &amp; Fees: $26.00 per month
  </p>
  <p style={{ paddingTop: "5pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s14"
    style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
  >
    What is it?
  </p>
  <p
    className="s15"
    style={{
      paddingTop: "4pt",
      paddingLeft: "24pt",
      textIndent: "0pt",
      lineHeight: "131%",
      textAlign: "left"
    }}
  >
    Non-Trucking Liability pays damages to 3rd party property or people
    (auto-liability) when not in the business of trucking. This program includes
    coverage for Underinsured and Uninsured motorist and Personal Injury
    Protection at your States Required Minimums.
  </p>
  <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s14"
    style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
  >
    Why buy it?
  </p>
  <ul id="l3">
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Your contract with your motor carrier may require you to carry
        Non-Trucking Liability.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        You are responsible for liability coverage for personal use of your
        truck.
      </p>
      <p
        className="s14"
        style={{
          paddingTop: "3pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          lineHeight: "36pt",
          textAlign: "left"
        }}
      >
        Limit: $1,000,000 Enhancements
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "90pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        To/From or Commuter: expanded coverage to include trips to and from your
        trucks regular garaged location and assigned terminal of lessee.
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingLeft: "90pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        Maintenance: expanded coverage to include trips to and from your trucks
        regular garaged location and maintenance facility for purpose of have
        regular maintenance performed.
      </p>
      <h2
        style={{
          paddingTop: "13pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        PHYSICAL DAMAGE – GREAT AMERICAN
      </h2>
      <p
        className="s15"
        style={{
          paddingTop: "8pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Physical Damage insurance pays for damages to your covered truck or
        trailer resulting from a covered claim.
      </p>
      <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s14"
        style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
      >
        Program Pricing &amp; Fees: $3.567 per $1, 000 value per month
      </p>
      <p
        className="s22"
        style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
      >
        Example Cost:{" "}
        <span className="s23">
          $50,000/$1,000 x $3.567 = $178.35 monthly cost
        </span>
      </p>
      <p style={{ paddingTop: "5pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "40.38pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p
                className="s24"
                style={{
                  paddingTop: "2pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Limits
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s25"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Any One Vehicle
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s26"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "18pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Lesser of Stated Amount or ACV
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s25"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Any One Combination of Vehicles
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s26"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "18pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Lesser of Stated Amount or ACV
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s25"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Towing &amp; Storage
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s26"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "18pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                $25,000
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p
                className="s24"
                style={{
                  paddingTop: "2pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Deductible
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#6C6C6C"
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s25"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Per Unit or Combined Tractor/Trailer
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s26"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "18pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Combined
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s25"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Collision
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s26"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "18pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                $1,000
              </p>
            </td>
          </tr>
          <tr style={{ height: "17pt" }}>
            <td
              style={{
                width: "157pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s25"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Comprehensive
              </p>
            </td>
            <td
              style={{
                width: "177pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
            >
              <p
                className="s26"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "18pt",
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                $1,000
              </p>
            </td>
          </tr>
          <tr style={{ height: "19pt" }}>
            <td
              style={{
                width: "334pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD"
              }}
              colSpan={2}
              color="#6C6C6C"
            >
              <p
                className="s24"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Valuation: Lesser of Actual Cash Value, Stated Amount or Cost of
                Repair
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s14"
        style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
      >
        Rig Ready Nationwide Network
      </p>
      <p
        className="s15"
        style={{
          paddingTop: "14pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          lineHeight: "131%",
          textAlign: "left"
        }}
      >
        When your rig is down, we’re here to help. As a customer of our Trucking
        Division, you can get your wheels back in action an average of five days
        faster with our signature Rig Ready program.* This streamlined service
        is included with your Physical Damage policy. With Rig Ready, you’ll
        have access to nearly{" "}
        <span className="s27">300 high-quality shops</span> across the country.
        We hand-pick only the best shops and work directly with them to
        negotiate discounts and payment.
      </p>
      <p
        className="s14"
        style={{
          paddingTop: "8pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        How Rig Ready Works
      </p>
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "24pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Find a shop
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s29"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          lineHeight: "127%",
          textAlign: "left"
        }}
      >
        <span className="p">
          Your claims adjuster will help you find a Rig Ready shop. You can also
          call our toll-free Rig Ready line at 800-643-7882, visit
          GreatAmericanTrucker.com.{" "}
        </span>
        Download the Trucking Mobile App for{" "}
        <span className="s30">iPhone®</span> or{" "}
        <span className="s30">Android®</span>
      </p>
      <p
        className="s15"
        style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
      >
        Start Repairs
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          lineHeight: "128%",
          textAlign: "left"
        }}
      >
        Qualified personnel will inspect your truck and prepare an estimate for
        repairs. We’ll approve the repair estimate, usually within just a few
        hours! There’s no need to wait for an external appraiser. Then, with
        your authorization, the shop can get started.
      </p>
      <p
        className="s15"
        style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
      >
        Get Moving
      </p>
    </li>
    <li data-list-text="•">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          lineHeight: "127%",
          textAlign: "left"
        }}
      >
        When your rig is ready, you can roll! Shops will release your truck as
        soon as repairs are complete – even if they haven’t received payment
        from us yet. All you pay is your deductible and applicable charges.
        Great American takes care of the rest.
      </p>
    </li>
  </ul>
  <p
    className="s32"
    style={{
      paddingTop: "9pt",
      paddingLeft: "24pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    * Based on a 2013 internal study comparing Rig Ready turnaround times to
    non-program claims.
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "55.184pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "482pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          colSpan={2}
          color="#6C6C6C"
        >
          <p
            className="s33"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            TruXpro Physical Damage Enhancements: Included when enrolled in
            Physical Damage.
          </p>
        </td>
      </tr>
      <tr style={{ height: "47pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
        >
          <p
            style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}
          >
            <br />
          </p>
          <p
            className="s25"
            style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
          >
            Diminishing Deductible
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
        >
          <p
            className="s26"
            style={{
              paddingTop: "4pt",
              paddingLeft: "9pt",
              paddingRight: "12pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Your deductible will decrease 25% of the deductible amount at policy
            inception for every year in which the insured does not have a loss
            until the deductible reaches $0. The deductible will reset to the
            original amount as at policy inception when the insured has a loss.
          </p>
        </td>
      </tr>
      <tr style={{ height: "32pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          color="#F0F0F0"
        >
          <p
            className="s25"
            style={{
              paddingTop: "9pt",
              paddingLeft: "9pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Single Deductible
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          color="#F0F0F0"
        >
          <p
            className="s26"
            style={{
              paddingTop: "2pt",
              paddingLeft: "9pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Pay only one deductible for damages to your tractor and trailer when
            both are insured by this policy and are damaged by the same covered
            cause of loss.
          </p>
        </td>
      </tr>
      <tr style={{ height: "50pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
        >
          <p
            style={{ paddingTop: "7pt", textIndent: "0pt", textAlign: "left" }}
          >
            <br />
          </p>
          <p
            className="s25"
            style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
          >
            Lease &amp; Loan GAP
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
        >
          <p
            className="s26"
            style={{
              paddingTop: "5pt",
              paddingLeft: "9pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            In the event of a total loss, pays up to $20,000 above the actual
            cash value of covered auto at time of loss if covered auto is listed
            under a loan agreement and the covered auto stated amount is equal
            to or greater than the amount owed on the loan agreement. Further
            exclusions apply.
          </p>
        </td>
      </tr>
      <tr style={{ height: "140pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          color="#F0F0F0"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s25"
            style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
          >
            Personal Contents
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          color="#F0F0F0"
        >
          <p
            className="s26"
            style={{
              paddingTop: "6pt",
              paddingLeft: "9pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Provides coverage for loss of personal belongings that are kept in
            your scheduled vehicle. Pays the lesser of actual cash value, repair
            cost or replacement cost, up to a limit of $5,000 for any one loss
            subject to a $250 deductible, for loss to personal property or
            effects of the insured. The property must be in the covered auto at
            the time of loss. Benefits are not available for the following:
            Accounts, bills, currency, deeds, evidence of debt, money, notes or
            securities; Electronic equipment or tapes, records, discs or other
            similar audio visual or data electronic equipment; Jewelry, watches,
            necklaces, bracelets or rings; Precious metals and stones such as
            gems, gold, platinum or silver; Furs; Animals, birds or fish;
            Motorized vehicles; In the event of other insurance for the same
            loss, the coverage provided by this endorsement will be excess over
            any other collectable insurance. Other exclusions apply.
          </p>
        </td>
      </tr>
      <tr style={{ height: "162pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s25"
            style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
          >
            Electronic Equipment
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
        >
          <p
            className="s26"
            style={{
              paddingTop: "5pt",
              paddingLeft: "9pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Pays the lesser of actual cash value, repair cost or replacement
            cost, up to a limit of $5,000 for any one loss subject to a $250
            deductible, for loss to electronic equipment, including satellite
            communication equipment, antennas, tapes, records, discs or other
            similar devices used with the electronic equipment and other
            accessories used for audio, visual or data purposes. At the time of
            loss the equipment must be in or on the covered auto. Benefits are
            not available for the following: Equipment used to operate the
            covered auto; Radar detection devices; Actual data, however
            maintained; Facts, concepts or instructions converted to a form for
            use with electronic equipment; The cost to reproduce or replace
            information placed on electronic equipment; Any satellite and
            satellite equipment, speakers, stereo equipment, computers and
            computer equipment, monitors or televisions not permanently
            installed to the covered auto. In the event of other insurance for
            the same loss, the coverage provided by this endorsement will be
            excess over any other collectable insurance. Other exclusions apply.
          </p>
        </td>
      </tr>
      <tr style={{ height: "98pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          color="#F0F0F0"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s25"
            style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
          >
            Downtime
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#BDBDBD"
          }}
          color="#F0F0F0"
        >
          <p
            className="s26"
            style={{
              paddingTop: "4pt",
              paddingLeft: "9pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Provides coverage for downtime in an amount of up to a maximum of
            $150 each day, or $750 a week, subject to a maximum of $5,000 each
            loss incurred after the waiting period. A seven (7) day waiting
            period applies beginning the day the insurer agrees to pay for
            appraised repairs, you give authorization of repair and deliver auto
            for commencement of all appraised repairs. If we determine the
            covered auto to be a total loss, the waiting period begins when we
            first inspect the vehicle and continues for seven days thereafter.
            No benefits will apply if you have a spare and/or substitute auto
            available for use.
          </p>
        </td>
      </tr>
      <tr style={{ height: "45pt" }}>
        <td
          style={{
            width: "112pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD"
          }}
        >
          <p
            style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}
          >
            <br />
          </p>
          <p
            className="s25"
            style={{ paddingLeft: "9pt", textIndent: "0pt", textAlign: "left" }}
          >
            Tarps, Chains and Binders
          </p>
        </td>
        <td
          style={{
            width: "370pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#BDBDBD"
          }}
        >
          <p
            className="s26"
            style={{
              paddingTop: "8pt",
              paddingLeft: "9pt",
              paddingRight: "10pt",
              textIndent: "0pt",
              lineHeight: "113%",
              textAlign: "left"
            }}
          >
            Provides coverage for loss of tarps, chains and binders up to a
            limit of $1,000 and subject to a deductible of $100 per loss if the
            loss occurs while the tarps, chains and binders are used with
          </p>
          <p
            className="s26"
            style={{
              paddingLeft: "9pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            the insured trailer or semi-trailer as described in the
            policy/certificate.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <h2
    style={{
      paddingTop: "6pt",
      paddingLeft: "24pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    AUTO LIABILITY DEDUCTIBLE
  </h2>
  <p
    className="s15"
    style={{
      paddingTop: "15pt",
      paddingLeft: "24pt",
      textIndent: "0pt",
      lineHeight: "131%",
      textAlign: "justify"
    }}
  >
    Per the terms of your Independent Contractor Operating Agreement with
    Western Express, you are required to carry insurance to satisfy your
    $250,000 auto liability deductible responsibility. Western Express has a
    program available to meet this contractual requirement (see prior page).{" "}
    <b>
      If you choose to enroll in the Western Express Deductible Buy Back program
      no further action is required below.
    </b>
  </p>
  <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s15"
    style={{
      paddingLeft: "24pt",
      textIndent: "0pt",
      lineHeight: "131%",
      textAlign: "left"
    }}
  >
    Western Express encourages you to research alternative options to meet your
    $250,000 auto liability deductible requirement. The list of insurance
    companies below may provide options for you. Western Express is not
    recommending the insurance companies below. This list was compiled only for
    your convenience. This list is not all inclusive and other insurance
    companies may be available.
  </p>
  <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s15"
    style={{
      paddingLeft: "24pt",
      textIndent: "0pt",
      lineHeight: "132%",
      textAlign: "left"
    }}
  >
    Please send this document to the insurance company to properly communicate
    your required insurance.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s14"
    style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
  >
    Policy requirements
  </p>
  <ul id="l4">
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "2pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Commercial Auto Liability policy with minimum per occurrence limit of
        $250,000
      </p>
    </li>
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Motor Carrier Coverage policy form or Business Auto policy form are
        acceptable
      </p>
    </li>
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        No Federal (MCS-90) or State filings are required
      </p>
    </li>
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Western Express, Inc. PO Box 280958 Nashville, TN 37228 named as
        Additional Insured
      </p>
      <p style={{ paddingTop: "7pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s15"
        style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}
      >
        Insurance Companies who may provide alternative insurance options for
        you
      </p>
    </li>
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        <a
          href="http://www.progressivecommercial.com/"
          className="a"
          target="_blank"
        >
          Progressive{" "}
        </a>
        www.progressivecommercial.com or (888) 806-9598
      </p>
    </li>
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        <a
          href="http://www.geico.com/commercial-auto-insurance"
          className="a"
          target="_blank"
        >
          GEICO{" "}
        </a>
        www.geico.com/commercial-auto-insurance or (866) 509-9444
      </p>
    </li>
    <li data-list-text="">
      <p
        className="s15"
        style={{
          paddingTop: "3pt",
          paddingLeft: "90pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        <a
          href="http://www.ooidatruckinsurance.com/"
          className="a"
          target="_blank"
        >
          OOIDA{" "}
        </a>
        www.ooidatruckinsurance.com or (800) 715-9369
      </p>
    </li>
  </ul>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "213pt", textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", paddingLeft: "0pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "20pt" }}>
        <td style={{ width: "329pt" }}>
          <p
            className="s35"
            style={{
              textIndent: "0pt",
              lineHeight: "15pt",
              textAlign: "center"
            }}
          >
            GREAT AMERICAN SPIRIT INSURANCE COMPANY
          </p>
        </td>
      </tr>
      <tr style={{ height: "15pt" }}>
        <td style={{ width: "329pt" }}>
          <p
            className="s36"
            style={{
              paddingTop: "3pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            OCCUPATIONAL ACCIDENT INSURANCE ENROLLMENT FORM
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.444pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "135pt" }}>
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Policyholder:
          </p>
        </td>
        <td style={{ width: "169pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "73pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Western Express, Inc.
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "135pt" }}>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td style={{ width: "169pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "73pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            7135 Centennial Place
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "135pt" }}>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td style={{ width: "169pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "73pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Nashville,TN 37209
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.444pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "185pt" }}>
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Insured Person's Monthly Premium:
          </p>
        </td>
        <td style={{ width: "46pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "23pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            $119
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "185pt" }}>
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Policy Number:
          </p>
        </td>
        <td style={{ width: "46pt" }}>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.444pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "483pt" }}>
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Classes of Eligible Persons:
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td style={{ width: "483pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            Class Description of Class
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td style={{ width: "483pt" }}>
          <p
            className="s38"
            style={{
              paddingLeft: "40pt",
              paddingRight: "14pt",
              textIndent: "-29pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            1 All Owner-Operators between the ages of 23-90 who are under
            contract with the Policyholder who have enrolled for coverage under
            this Policy.
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "483pt" }}>
          <p
            className="s38"
            style={{
              paddingLeft: "10pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            3 All Contract Drivers between the ages of 23-90 who are under
            contract with the Owner-Operator who have
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "6.284pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "16pt" }}>
        <td style={{ width: "206pt" }} color="#DADADA">
          <p
            className="s39"
            style={{
              paddingLeft: "3pt",
              textIndent: "0pt",
              lineHeight: "15pt",
              textAlign: "left"
            }}
          >
            Schedule of Benefits: Coverage
          </p>
        </td>
        <td style={{ width: "186pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td style={{ width: "187pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            Class 1: Owner-Operators
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            DESCRIPTION OF BENEFITS:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            OCCUPATIONAL
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            NON-OCCUPATIONAL
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            ACCIDENTAL DEATH BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $50,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $10,000
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            SURVIVOR'S BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $250,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Monthly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $2,500
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Number of Months:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            100
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            0
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            ACCIDENTAL DISMEMBERMENT &amp;
          </p>
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            PARALYSIS BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $300,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $10,000
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Maximum Number of Months:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            24
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            24
          </p>
        </td>
      </tr>
      <tr style={{ height: "37pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Monthly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "8pt",
              paddingRight: "6pt",
              textIndent: "0pt",
              lineHeight: "108%",
              textAlign: "center"
            }}
          >
            Percentage of Principal Sum for Covered Loss, divided by the Maximum
            number of
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Months
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "8pt",
              paddingRight: "6pt",
              textIndent: "0pt",
              lineHeight: "108%",
              textAlign: "center"
            }}
          >
            Percentage of Principal Sum for Covered Loss, divided by the Maximum
            number of
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Months
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            ACCIDENT MEDICAL EXPENSE BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Scope of Coverage:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Excess
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Excess
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $1,000,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $10,000
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            104 Weeks
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            104 Weeks
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            90 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            90 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Deductible:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0 Per Accident
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0 Per Accident
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Coinsurance:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            100% of Usual and Customary Charges
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            100% of Usual and Customary Charges
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit for Ambulance Services:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Maximum Benefit for Dental Expenses:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $1,000 Per Accident
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $10,000 Lifetime Maximum
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $1,000 Per Accident
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $10,000 Lifetime Maximum
          </p>
        </td>
      </tr>
      <tr style={{ height: "38pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "14pt",
              paddingRight: "1pt",
              textIndent: "25pt",
              lineHeight: "108%",
              textAlign: "left"
            }}
          >
            Maximum Benefit for Physical Therapy, Occupational Therapy and
            Chiropractic Care:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            TEMPORARY TOTAL DISABILITY
          </p>
          <p
            className="s36"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            BENEFIT *
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Benefit Percentage:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            70% of Average Weekly Earnings
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Weekly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $700
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Minimum Weekly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $200
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            104 Weeks
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Waiting Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            7 Days Retroactive
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            CONTINUOUS TOTAL DISABILITY
          </p>
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            BENEFIT *
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
          rowSpan={4}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "7pt",
              paddingRight: "1pt",
              textIndent: "29pt",
              lineHeight: "111%",
              textAlign: "left"
            }}
          >
            Up to a Maximum of $2,580 Subject to all policy terms and provisions
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              paddingRight: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Social Security Retirement Age
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              paddingRight: "2pt",
              textIndent: "0pt",
              lineHeight: "12pt",
              textAlign: "center"
            }}
          >
            Equals the Maximum Benefit Period for Temporary Total Disability
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "18pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Monthly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "18pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingTop: "6pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Period **:
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingTop: "6pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Waiting Period:
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            COMBINED SINGLE LIMIT
          </p>
        </td>
        <td
          style={{
            width: "373pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
          colSpan={2}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "1pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            $1,000,000 per Insured Person
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.444pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "24pt" }}>
        <td style={{ width: "574pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            * Temporary &amp; Continuous Total Disability are subject to the
            lesser of: 70% of Average Weekly Earnings or the Weekly/Monthly
            Benefit
          </p>
          <p
            className="s37"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            Amount Shown
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td style={{ width: "574pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            ** Social Security Retirement Age (SSRA) will vary depending upon
            the Insured Person’s date of birth. If the Insured Person reaches
            his/her SSRA before satisfying the waiting period, he/she may not
            qualify for Continuous Total Disability Benefits.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "6.284pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "17pt" }}>
        <td style={{ width: "206pt" }} color="#DADADA">
          <p
            className="s39"
            style={{
              paddingLeft: "3pt",
              textIndent: "0pt",
              lineHeight: "15pt",
              textAlign: "left"
            }}
          >
            Optional Additional Benefits
          </p>
        </td>
        <td style={{ width: "186pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td style={{ width: "187pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p
            className="s36"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            Class 1: Owner-Operators
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            DESCRIPTION OF BENEFITS:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            OCCUPATIONAL
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            NON-OCCUPATIONAL
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Severe Burn Benefit
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "65pt",
              paddingRight: "1pt",
              textIndent: "-52pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Included in Accidental Dismemberment Principal Sum
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "65pt",
              paddingRight: "1pt",
              textIndent: "-52pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Included in Accidental Dismemberment Principal Sum
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "6.284pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "17pt" }}>
        <td style={{ width: "206pt" }} color="#DADADA">
          <p
            className="s39"
            style={{
              paddingLeft: "3pt",
              textIndent: "0pt",
              lineHeight: "15pt",
              textAlign: "left"
            }}
          >
            Schedule of Benefits: Coverage
          </p>
        </td>
        <td style={{ width: "186pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td style={{ width: "187pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            Class 3: Contract Drivers
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            DESCRIPTION OF BENEFITS:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            OCCUPATIONAL
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            NON-OCCUPATIONAL
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            ACCIDENTAL DEATH BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $50,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $10,000
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            SURVIVOR'S BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $250,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Monthly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $2,500
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Maximum Number of Months:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            100
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            0
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            ACCIDENTAL DISMEMBERMENT &amp;
          </p>
          <p
            className="s36"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            PARALYSIS BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $300,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $10,000
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Number of Months:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            24
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            24
          </p>
        </td>
      </tr>
      <tr style={{ height: "37pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Monthly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "8pt",
              paddingRight: "6pt",
              textIndent: "0pt",
              lineHeight: "12pt",
              textAlign: "center"
            }}
          >
            Percentage of Principal Sum for Covered Loss, divided by the Maximum
            number of Months
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "8pt",
              paddingRight: "6pt",
              textIndent: "0pt",
              lineHeight: "12pt",
              textAlign: "center"
            }}
          >
            Percentage of Principal Sum for Covered Loss, divided by the Maximum
            number of Months
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            ACCIDENT MEDICAL EXPENSE BENEFIT
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Scope of Coverage:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Excess
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Excess
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $1,000,000
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $10,000
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            104 Weeks
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            104 Weeks
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            90 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            90 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Deductible:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0 Per Accident
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $0 Per Accident
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Coinsurance:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            100% of Usual and Customary Charges
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            100% of Usual and Customary Charges
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Maximum Benefit for Ambulance Services:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Maximum Benefit for Dental Expenses:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $1,000 Per Accident
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $10,000 Lifetime Maximum
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            $0
          </p>
        </td>
      </tr>
      <tr style={{ height: "38pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "14pt",
              paddingRight: "1pt",
              textIndent: "25pt",
              lineHeight: "107%",
              textAlign: "left"
            }}
          >
            Maximum Benefit for Physical Therapy, Occupational Therapy and
            Chiropractic Care:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            No Sublimit Applies
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            TEMPORARY TOTAL DISABILITY
          </p>
          <p
            className="s36"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            BENEFIT *
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Benefit Percentage:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            70% of Average Weekly Earnings
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Weekly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $600
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Minimum Weekly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            $200
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            104 Weeks
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Waiting Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            7 Days Retroactive
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            CONTINUOUS TOTAL DISABILITY
          </p>
          <p
            className="s36"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            BENEFIT *
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Monthly Benefit Amount:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Up to a Maximum of $2,580
          </p>
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              paddingRight: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Subject to all policy terms and provisions
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Maximum Benefit Period **:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Social Security Retirement Age
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Waiting Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "39pt",
              paddingRight: "10pt",
              textIndent: "-27pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Equals the Maximum Benefit Period for Temporary Total Disability
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Not Covered
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            COMBINED SINGLE LIMIT
          </p>
        </td>
        <td
          style={{
            width: "373pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
          colSpan={2}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "1pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            $1,000,000 per Insured Person
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.444pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "24pt" }}>
        <td style={{ width: "574pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            * Temporary &amp; Continuous Total Disability are subject to the
            lesser of: 70% of Average Weekly Earnings or the Weekly/Monthly
            Benefit
          </p>
          <p
            className="s37"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            Amount Shown
          </p>
        </td>
      </tr>
      <tr style={{ height: "24pt" }}>
        <td style={{ width: "574pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            ** Social Security Retirement Age (SSRA) will vary depending upon
            the Insured Person’s date of birth. If the Insured Person reaches
            his/her SSRA before satisfying the waiting period, he/she may not
            qualify for Continuous Total Disability Benefits.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "6.284pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "17pt" }}>
        <td style={{ width: "206pt" }} color="#DADADA">
          <p
            className="s39"
            style={{
              paddingLeft: "3pt",
              textIndent: "0pt",
              lineHeight: "15pt",
              textAlign: "left"
            }}
          >
            Optional Additional Benefits
          </p>
        </td>
        <td style={{ width: "186pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td style={{ width: "187pt" }} color="#DADADA">
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p
            className="s36"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            Class 3: Contract Drivers
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt"
          }}
          color="#DADADA"
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            DESCRIPTION OF BENEFITS:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            OCCUPATIONAL
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "center"
            }}
          >
            NON-OCCUPATIONAL
          </p>
        </td>
      </tr>
      <tr style={{ height: "12pt" }}>
        <td
          style={{
            width: "206pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s36"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "10pt",
              textAlign: "left"
            }}
          >
            Severe Burn Benefit
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "13pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "right"
            }}
          >
            Commencement Period:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "center"
            }}
          >
            365 Days
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td
          style={{
            width: "206pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p className="s37" style={{ textIndent: "0pt", textAlign: "right" }}>
            Principal Sum:
          </p>
        </td>
        <td
          style={{
            width: "186pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "65pt",
              paddingRight: "1pt",
              textIndent: "-52pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Included in Accidental Dismemberment Principal Sum
          </p>
        </td>
        <td
          style={{
            width: "187pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "65pt",
              paddingRight: "1pt",
              textIndent: "-52pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Included in Accidental Dismemberment Principal Sum
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.804pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "74pt" }}>
        <td
          style={{
            width: "579pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingLeft: "6pt",
              paddingRight: "4pt",
              textIndent: "0pt",
              lineHeight: "108%",
              textAlign: "center"
            }}
          >
            The list of benefits is only a brief description of the actual
            coverages. Certain exclusions and limitations do apply. For complete
            details please refer to your policy. In the event of any conflict
            between the information listed here and the actual policy, the
            insurance policy will govern in all cases.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "5pt",
              paddingRight: "4pt",
              textIndent: "0pt",
              lineHeight: "108%",
              textAlign: "center"
            }}
          >
            Social Security Retirement Age (SSRA) will vary depending upon the
            Insured Person’s date of birth. If the Insured Person reaches
            his/her SSRA before satisfying the waiting period, he/she may not
            qualify for Continuous Total Disability Benefits.
          </p>
        </td>
      </tr>
      <tr style={{ height: "64pt" }}>
        <td
          style={{
            width: "579pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt"
          }}
        >
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Please print
          </p>
          <p
            className="s37"
            style={{
              paddingTop: "6pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Name:{" "}
            <u>
            {props.viewObject !== undefined ? props.viewObject.driverName1 : props.ownerData.name}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Male:{" "}
            <u>
            &nbsp;{ props.viewObject !== undefined ? props.viewObject.sex === "male" ? 'X' : '' : props.mf === "male" ? 'X' : ''}&nbsp;
            </u>
            &nbsp;
            Female:{" "}
            <u>
            &nbsp;{ props.viewObject !== undefined ? props.viewObject.sex === "male" ? '' : 'X' : props.mf === "male" ? '' : 'X'}&nbsp;
            </u>
          </p>
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              paddingRight: "93pt",
              textIndent: "0pt",
              lineHeight: "14pt",
              textAlign: "left"
            }}
          >
            Street Address:
            <u>
              {props.viewObject !== undefined ? props.viewObject.streetAddress : props.ownerData.address}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            City:{" "}
            <u>
            {props.viewObject !== undefined ? props.viewObject.city : props.ownerData.city}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            State: <u>{props.viewObject !== undefined ? props.viewObject.state : props.ownerData.state}</u>&nbsp; 
            Zip: <u>{props.viewObject !== undefined ? props.viewObject.zip : props.ownerData.zip}</u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Social Security Number:{" "}
            <u>
              {props.viewObject !== undefined ? props.viewObject.ssn : props.ssn}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
            </p>
            Date of Birth:{" "}
            <u>
              {props.viewObject !== undefined ? props.viewObject.DOB : convertDOYtoSQL(userInfo.birthdate.toString())}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
            </p>
            E-mail Address:{" "}
            <u>
              {props.viewObject !== undefined ? props.viewObject.email : userInfo.email}
            </u>
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td style={{ width: "579pt" }}>
          <p
            className="s37"
            style={{
              paddingTop: "2pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "130%",
              textAlign: "justify"
            }}
          >
            Home Telephone Number:{" "}
            <u>
            { props.viewObject !== undefined ? props.viewObject.OwnerPhone : props.ownerData!.areaCode.toString() + props.ownerData!.phoneNumber.toString()}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Cell Telephone Number:{" "}
            <u>
            { props.viewObject !== undefined ? props.viewObject.OwnerPhone : props.ownerData!.areaCode.toString() + props.ownerData!.phoneNumber.toString()}
            </u>{" "}
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Name of Beneficiary:{" "}
            <u>
            {props.viewObject !== undefined ? props.viewObject.beneficiary1 : null}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Relationship of Beneficiary:{" "}
            <u>
            {props.viewObject !== undefined ? props.viewObject.relationship1 : null}
            </u>{" "}
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            CDL Number:{" "}
            <u>
              {props.viewObject !== undefined ? props.viewObject.cdlNumber : props.cdlNumber}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Number of Years Experience:{" "}
            <u>
              {props.viewObject !== undefined ? props.viewObject.yearsExperience : props.yearsExperience}
            </u>
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Contracted by (Name of Company): Western Express Inc. Effective Date
            of Contract:{" "}
            <u>
              {props.viewObject !== undefined ? props.viewObject.date1 : props.date}
            </u>
          </p>
        </td>
      </tr>
      <tr style={{ height: "46pt" }}>
        <td style={{ width: "579pt" }}>
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "1pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Street Address: 7135 Centennial Place City: Nashville State: TN Zip:
            37209
          </p>
          <p
            className="s37"
            style={{
              paddingTop: "3pt",
              paddingLeft: "1pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Policyholder or Motor Carrier Telephone Number: 
            <u>615-846-8123</u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Fax Number:{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </u>
          </p>
          <p
            style={{
              paddingTop: "6pt",
              paddingLeft: "1pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            <a
              href="mailto:mmcgarey@westernexp.com"
              className="s41"
              target="_blank"
            >
              Policyholder or Motor Carrier E-Mail Address:
              <u>mmcgarey@westernexp.com</u>
            </a>
          </p>
        </td>
      </tr>
      <tr style={{ height: "44pt" }}>
        <td style={{ width: "579pt" }}>
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Are you an Owner-Operator? Yes{" "}
            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; x &nbsp;&nbsp;&nbsp;&nbsp; </u>No
          </p>
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            If yes, is the Certificate of Title in your name? Yes{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>
            No{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; x &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </u>
          </p>
          <p
            className="s37"
            style={{
              paddingTop: "1pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            If no, are you a: Co-Owner{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>
            Co-Driver{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>
            Team Driver{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>
            Contract Driver{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; x &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </u>
          </p>
        </td>
      </tr>
      <tr style={{ height: "45pt" }}>
        <td style={{ width: "579pt" }}>
          <p
            className="s37"
            style={{
              paddingTop: "6pt",
              paddingLeft: "17pt",
              paddingRight: "38pt",
              textIndent: "0pt",
              lineHeight: "112%",
              textAlign: "left"
            }}
          >
            Scheduled Co-Driver{" "}
            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Fleet Driver{" "}
            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Leased Driver{" "}
            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>{" "}
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Authorized Passenger{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Casual Laborer{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            or Other{" "}
            <u>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </u>{" "}
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
            Paid by: 1099 (x) W-2 ( )
          </p>
        </td>
      </tr>
      <tr style={{ height: "25pt" }}>
        <td style={{ width: "579pt" }}>
          <p
            className="s42"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            For residents of Maine and Tennessee:{" "}
            <span className="s37">
              It is a crime to knowingly provide false, incomplete or misleading
              information to an insurance company for the purpose of defrauding
              the company. Penalties include imprisonment, fines or denial of
              insurance benefits.
            </span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.444pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "12pt" }}>
        <td style={{ width: "578pt" }}>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            I understand and hereby acknowledge the following:
          </p>
        </td>
      </tr>
      <tr style={{ height: "35pt" }}>
        <td style={{ width: "578pt" }}>
          <p
            className="s37"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
          >
            1. This coverage is not Workers’ Compensation Insurance or for any
            other purpose except occupational accidents (unless non-
          </p>
          <p
            className="s37"
            style={{
              paddingLeft: "2pt",
              textIndent: "0pt",
              lineHeight: "11pt",
              textAlign: "left"
            }}
          >
            occupational benefits apply). I nor the Policyholder above can
            become participants in the Workers’ Compensation system by
            purchasing this insurance;
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <ol id="l5">
    <li data-list-text={2}>
      <p
        className="s43"
        style={{
          paddingLeft: "7pt",
          textIndent: "0pt",
          lineHeight: "108%",
          textAlign: "justify"
        }}
      >
        This is a limited benefit policy. It does not provide comprehensive
        health insurance coverage. It does not satisfy the requirements of
        minimum essential coverage under the Affordable Care Act or its
        equivalent;
      </p>
      <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={3}>
      <p
        className="s43"
        style={{
          paddingLeft: "28pt",
          textIndent: "-21pt",
          textAlign: "justify"
        }}
      >
        This policy does not cover pre-existing conditions, unless otherwise
        endorsed;
      </p>
      <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={4}>
      <p
        className="s43"
        style={{
          paddingLeft: "7pt",
          textIndent: "0pt",
          lineHeight: "108%",
          textAlign: "justify"
        }}
      >
        To the best of my knowledge and belief, all information I have provided
        is true and complete. I understand my information is protected by
        privacy laws and will be released only in accordance with these laws;
      </p>
      <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={5}>
      <p
        className="s43"
        style={{
          paddingLeft: "7pt",
          textIndent: "0pt",
          lineHeight: "108%",
          textAlign: "justify"
        }}
      >
        I certify that I meet the eligibility requirements under the Policy. I
        understand that if I am not eligible, no benefits will be paid and this
        coverage will be cancelled. I further understand that coverage
        terminates on the date the policy is terminated, or I am no longer under
        contract with the above mentioned policyholder, or my premium is not
        paid;
      </p>
      <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={6}>
      <p
        className="s43"
        style={{
          paddingLeft: "7pt",
          textIndent: "0pt",
          lineHeight: "108%",
          textAlign: "justify"
        }}
      >
        I authorize any licensed physician, medical practitioner, hospital,
        clinic, or other medical or medically related facility, insurance
        company or any other organization, institution or person that has any
        records, including any medical records to furnish such information or
        copies of records to Great American Spirit Insurance Company, the
        Policyholder or the Policyholder’s designee. A photographic copy of this
        authorization shall be as valid as the original
      </p>
      <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={7}>
      <p
        className="s43"
        style={{
          paddingLeft: "7pt",
          textIndent: "0pt",
          lineHeight: "108%",
          textAlign: "justify"
        }}
      >
        I understand that coverage becomes effective when this application has
        been received and approved by Great American Spirit Insurance Company or
        its authorized agent.
      </p>
      <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s44"
        style={{
          paddingLeft: "7pt",
          textIndent: "0pt",
          lineHeight: "111%",
          textAlign: "justify"
        }}
      >
        I accept the insurance elected above voluntarily. If at a later date I
        wish to participate in a coverage I have not elected, I understand that
        my coverage is subject to the terms and conditions of the policy and
        acceptance by the Insurance Company. I understand I may be required to
        provide evidence of insurability at my own expense. If premiums are to
        be paid by payroll / account deduction, I authorize the necessary amount
        from my earnings/checking or savings account to be deducted.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s43"
        style={{ paddingLeft: "7pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Applicant's Signature
        {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
        Date Signed{" "}
        <u>
        {props.viewObject !== undefined ? props.viewObject.date1 : props.date}
        </u>
      </p>
      <p style={{ paddingLeft: "40pt", textIndent: "0pt", textAlign: "left" }}>
        <span />
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "31.954pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "22pt" }}>
            <td
              style={{
                width: "492pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD"
              }}
              colSpan={4}
              color="#626262"
            >
              <p
                className="s46"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "9pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Insurance Electives for Independent Contractors
              </p>
            </td>
          </tr>
          <tr style={{ height: "22pt" }}>
            <td
              style={{
                width: "176pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#626262"
            >
              <p
                className="s47"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "9pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Types of Insurance offered:
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#626262"
            >
              <p
                className="s47"
                style={{
                  paddingTop: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Price
              </p>
            </td>
            <td
              style={{
                width: "106pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#626262"
            >
              <p
                className="s47"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "19pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Calculation
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#626262"
            >
              <p
                className="s47"
                style={{
                  paddingTop: "4pt",
                  paddingLeft: "9pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Initial to Accept
              </p>
            </td>
          </tr>
          <tr style={{ height: "22pt" }}>
            <td
              style={{
                width: "176pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s20"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Occupational Accident Insurance
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s48"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                27.46
              </p>
            </td>
            <td
              style={{
                width: "106pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s49"
                style={{ textIndent: "0pt", textAlign: "center" }}
              >
                ---
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "22pt" }}>
            <td
              style={{
                width: "176pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p
                className="s20"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Physical Damage Insurance
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p
                className="s50"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "3pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                check oper. agr
              </p>
            </td>
            <td
              style={{
                width: "106pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "22pt" }}>
            <td
              style={{
                width: "176pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s20"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Deductible Buy Back Coverage
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s51"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                39.23
              </p>
            </td>
            <td
              style={{
                width: "106pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p
                className="s49"
                style={{
                  textIndent: "0pt",
                  lineHeight: "10pt",
                  textAlign: "center"
                }}
              >
                ---
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
              color="#F0F0F0"
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "22pt" }}>
            <td
              style={{
                width: "176pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p
                className="s20"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Non-Trucking Liability
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p
                className="s51"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                6.<span className="s48">69</span>
              </p>
            </td>
            <td
              style={{
                width: "106pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p
                className="s49"
                style={{
                  textIndent: "0pt",
                  lineHeight: "10pt",
                  textAlign: "center"
                }}
              >
                ---
              </p>
            </td>
            <td
              style={{
                width: "105pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#BDBDBD",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#BDBDBD",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#BDBDBD",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#BDBDBD"
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s52"
        style={{ paddingLeft: "30pt", textIndent: "0pt", textAlign: "left" }}
      >
        I authorize Western Express, Inc. to deduct these amounts from my weekly
        settlements.
      </p>
      <p style={{ paddingTop: "16pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s54"
        style={{ paddingLeft: "30pt", textIndent: "0pt", textAlign: "left" }}
      >
        <u>
          &nbsp; John Morris &nbsp;
        </u>{" "}
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "30.624pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "70pt" }}>
            <td
              style={{
                width: "225pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#808080"
              }}
              colSpan={2}
            >
              <p
                className="s55"
                style={{
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Western Express Representative ( Print)
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                <span />
              </p>
            </td>
            <td style={{ width: "41pt" }}>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "135pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#808080"
              }}
            >
              <p
                className="s55"
                style={{
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "left"
                }}
              >
                Contractor ( Print)
              </p>
              <p className="s55"
                style={{
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "right"
                }}>
              {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : null}
              </p>
            </td>
            <td
              style={{
                width: "90pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#808080"
              }}
            >
              <p
                className="s55"
                style={{
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "right"
                }}
              >
                Tractor #
              </p>
              <p className="s55"
                style={{
                  textIndent: "0pt",
                  lineHeight: "11pt",
                  textAlign: "right"
                }}>
              {props.viewObject !== undefined ? props.viewObject.date1 : props.date}
              </p>
            </td>
          </tr>
          <tr style={{ height: "15pt" }}>
            <td
              style={{
                width: "117pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#808080"
              }}
            >
              <p
                className="s55"
                style={{
                  paddingTop: "1pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                Signed
              </p>
            </td>
            <td
              style={{
                width: "108pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#808080"
              }}
            >
              <p
                className="s55"
                style={{
                  paddingTop: "1pt",
                  paddingRight: "1pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "right"
                }}
              >
                Date
              </p>
            </td>
            <td style={{ width: "41pt" }}>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "135pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#808080"
              }}
            >
              
              <p
                className="s55"
                style={{
                  paddingTop: "1pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "left"
                }}
              >
                Signed
              </p>
            </td>
            <td
              style={{
                width: "90pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#808080"
              }}
            >
              <p
                className="s55"
                style={{
                  paddingTop: "1pt",
                  paddingRight: "1pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "right"
                }}
              >
                Date
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s13"
        style={{
          paddingLeft: "40pt",
          textIndent: "0pt",
          lineHeight: "115%",
          textAlign: "center"
        }}
      >
        The information described herein is only intended to be a summary of
        your insurance options. It does not describe nor include all benefit
        provisions, limitations, exclusions, or qualifications for coverage.
        Please review your policy for a complete explanation of your benefits.
        If the benefits conflict in any way with the policy, the policy will
        prevail.
      </p>
      <p
        className="s56"
        style={{
          paddingLeft: "35pt",
          textIndent: "0pt",
          lineHeight: "13pt",
          textAlign: "center"
        }}
      >
        8
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <span />
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <span />
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <span />
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <span />
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <span />
      </p>
      <div
        className="textbox"
        style={{
          background: "#000000",
          display: "block",
          minHeight: "12.4pt",
          width: "36.2pt"
        }}
      >
        <p
          className="s57"
          style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
        >
          Part I
        </p>
      </div>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <div
    className="textbox"
    style={{
      border: "0.5pt solid #000000",
      display: "block",
      minHeight: "10.1pt",
      width: "158.4pt"
    }}
  >
    <p
      className="s58"
      style={{ paddingLeft: "3pt", textIndent: "0pt", textAlign: "left" }}
    >
      Social security number
    </p>
  </div>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <p
    className="s59"
    style={{
      paddingTop: "6pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      lineHeight: "93%",
      textAlign: "left"
    }}
  >
    <a>‌</a>Form <span className="s60">W-9 </span>(Rev. October
    2018) Department of the Treasury Internal Revenue Service
  </p>
  <p
    className="s61"
    style={{
      paddingTop: "8pt",
      paddingLeft: "22pt",
      textIndent: "55pt",
      lineHeight: "92%",
      textAlign: "left"
    }}
  >
    Request for Taxpayer Identification Number and Certification
  </p>
  <p
    className="s62"
    style={{
      paddingTop: "6pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    ▶{" "}
    <a
      href="http://www.irs.gov/FormW9"
      style={{
        color: "black",
        fontFamily: "Arial, sans-serif",
        fontStyle: "normal",
        fontWeight: "bold",
        textDecoration: "none",
        fontSize: "8pt"
      }}
      target="_blank"
    >
      Go to{" "}
    </a>
    <span className="s65">www.irs.gov/FormW9 </span>
    <span className="s63">for instructions and the latest information.</span>
  </p>
  <p style={{ paddingTop: "5pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s66"
    style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
  >
    Give Form to the requester. Do not send to the IRS.
  </p>
  <ol id="l6">
    <ol id="l7">
      <li data-list-text={1}>
        <p
          className="s59"
          style={{
            paddingTop: "2pt",
            paddingLeft: "39pt",
            textIndent: "-7pt",
            textAlign: "left"
          }}
        >
          Name (as shown on your income tax return). Name is required on this
          line; do not leave this line blank.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "center" }}>
          <u>{props.viewObject !== undefined ? props.viewObject.driverName1 : props.ownerData.name}</u>
        </p>
      </li>
      <li data-list-text={2}>
        <p
          className="s59"
          style={{ paddingLeft: "39pt", textIndent: "-7pt", textAlign: "left" }}
        >
          Business name/disregarded entity name, if different from above
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s63"
          style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "center" }}
        >
          Print or type.
        </p>
        <p className="s67" style={{ textIndent: "0pt", textAlign: "center" }}>
          See <b>Specific Instructions </b>on page 3.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }} />
      </li>
      <li data-list-text={3}>
        <p
          className="s59"
          style={{
            paddingTop: "5pt",
            paddingLeft: "39pt",
            textIndent: "-8pt",
            textAlign: "left"
          }}
        >
          Check appropriate box for federal tax classification of the person
          whose name is entered on line 1. Check only <b>one </b>of the
          following seven boxes.
        </p>
      </li>
      <li data-list-text={4}>
        <p
          className="s59"
          style={{
            paddingTop: "5pt",
            paddingLeft: "7pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          Exemptions (codes apply only to certain entities, not individuals; see
          instructions on page 3):
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s59"
          style={{
            paddingTop: "2pt",
            paddingLeft: "26pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          Individual/sole proprietor or single-member LLC
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s59"
          style={{
            paddingTop: "1pt",
            paddingLeft: "26pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          C Corporation 
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>S Corporation 
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>Partnership Trust/estate
        </p>
        <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s59"
          style={{ paddingLeft: "10pt", textIndent: "0pt", textAlign: "left" }}
        >
          Exempt payee code (if any)
        </p>
        <p
          className="s59"
          style={{
            paddingTop: "4pt",
            paddingLeft: "49pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          Limited liability company. Enter the tax classification (C=C
          corporation, S=S corporation, P=Partnership){" "}
          <span className="s69">▶</span>
        </p>
        <p
          className="s68"
          style={{
            paddingTop: "2pt",
            paddingLeft: "49pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          Note:{" "}
          <span className="s59">
            Check the appropriate box in the line above for the tax
            classification of the single-member owner. Do not check LLC if the
            LLC is classified as a single-member LLC that is disregarded from
            the owner unless the owner of the LLC is another LLC that is{" "}
          </span>
          not{" "}
          <span className="s59">
            disregarded from the owner for U.S. federal tax purposes. Otherwise,
            a single-member LLC that is disregarded from the owner should check
            the appropriate box for the tax classification of its owner.
          </span>
        </p>
        <p
          className="s59"
          style={{
            paddingTop: "3pt",
            paddingLeft: "49pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          Other (see instructions) <span className="s69">▶</span>
        </p>
        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s59"
          style={{
            paddingLeft: "3pt",
            textIndent: "0pt",
            lineHeight: "137%",
            textAlign: "left"
          }}
        >
          Exemption from FATCA reporting code (if any)
        </p>
        <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s70"
          style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
        >
          (Applies to accounts maintained outside the U.S.)
        </p>
      </li>
      <li data-list-text={5}>
        <p
          className="s59"
          style={{
            paddingTop: "1pt",
            paddingLeft: "39pt",
            textIndent: "-7pt",
            textAlign: "left"
          }}
        >
          Address (number, street, and apt. or suite no.) See instructions.
          Requester’s name and address (optional)
        </p>
        <p style={{ paddingTop: "7pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        {props.viewObject !== undefined ? props.viewObject.streetAddress : props.ownerData.address}
      </li>
      <li data-list-text={6}>
        <p
          className="s59"
          style={{ paddingLeft: "39pt", textIndent: "-7pt", textAlign: "left" }}
        >
          City, state, and ZIP code
        </p>
        <p style={{ paddingTop: "7pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        {props.viewObject !== undefined ? props.viewObject.city : props.ownerData.city} &nbsp;{props.viewObject !== undefined ? props.viewObject.state : props.ownerData.state}&nbsp;{props.viewObject !== undefined ? props.viewObject.zip : props.ownerData.zip}
      </li>
      <li data-list-text={7}>
        <p
          className="s59"
          style={{ paddingLeft: "38pt", textIndent: "-7pt", textAlign: "left" }}
        >
          List account number(s) here (optional)
        </p>
      </li>
    </ol>
  </ol>
  <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s71"
    style={{ paddingLeft: "61pt", textIndent: "0pt", textAlign: "left" }}
  >
    Taxpayer Identification Number (TIN)
  </p>
  <p
    className="s67"
    style={{
      paddingTop: "2pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Enter your TIN in the appropriate box. The TIN provided must match the name
    given on line 1 to avoid backup withholding. For individuals, this is
    generally your social security number (SSN). However, for a
  </p>
  <p
    className="s67"
    style={{
      paddingLeft: "6pt",
      textIndent: "0pt",
      lineHeight: "9pt",
      textAlign: "left"
    }}
  >
    resident alien, sole proprietor, or disregarded entity, see the instructions
    for Part I, later. For other <b>– –</b>
  </p>
  <p
    className="s67"
    style={{
      paddingLeft: "6pt",
      textIndent: "0pt",
      lineHeight: "9pt",
      textAlign: "left"
    }}
  >
    entities, it is your employer identification number (EIN). If you do not
    have a number, see <i>How to get a</i>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <p
    className="s68"
    style={{ paddingLeft: "3pt", textIndent: "0pt", textAlign: "left" }}
  >
    Employer identification number
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <p
    className="s72"
    style={{
      paddingLeft: "6pt",
      textIndent: "0pt",
      lineHeight: "10pt",
      textAlign: "left"
    }}
  >
    TIN, <span className="s67">later. </span>
    <span className="s66">or</span>
  </p>
  <p
    className="s63"
    style={{
      paddingTop: "7pt",
      paddingLeft: "7pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    –
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <p
    className="s67"
    style={{
      paddingTop: "2pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <b>Note: </b>If the account is in more than one name, see the instructions
    for line 1. Also see <i>What Name and Number To Give the Requester </i>for
    guidelines on whose number to enter.
  </p>
  <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
    <span className="s73" style={{ backgroundColor: "#000" }}>
      {" "}
      Part II{" "}
    </span>
    <span className="s74"></span>
    <span className="s71">Certification</span>
  </p>
  <p
    style={{
      paddingLeft: "5pt",
      textIndent: "0pt",
      lineHeight: "1pt",
      textAlign: "left"
    }}
  >
    <span />
  </p>
  <p
    className="s67"
    style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
  >
    Under penalties of perjury, I certify that:
  </p>
  <ol id="l8">
    <li data-list-text={1}>
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "14pt",
          textIndent: "-8pt",
          textAlign: "left"
        }}
      >
        The number shown on this form is my correct taxpayer identification
        number (or I am waiting for a number to be issued to me); and
      </p>
    </li>
    <li data-list-text={2}>
      <p
        className="s67"
        style={{ paddingLeft: "15pt", textIndent: "-9pt", textAlign: "left" }}
      >
        I am not subject to backup withholding because: (a) I am exempt from
        backup withholding, or (b) I have not been notified by the Internal
        Revenue Service (IRS) that I am subject to backup withholding as a
        result of a failure to report all interest or dividends, or (c) the IRS
        has notified me that I am no longer subject to backup withholding; and
      </p>
    </li>
    <li data-list-text={3}>
      <p
        className="s67"
        style={{
          paddingTop: "3pt",
          paddingLeft: "14pt",
          textIndent: "-8pt",
          textAlign: "left"
        }}
      >
        I am a U.S. citizen or other U.S. person (defined below); and
      </p>
    </li>
    <li data-list-text={4}>
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "14pt",
          textIndent: "-8pt",
          textAlign: "left"
        }}
      >
        The FATCA code(s) entered on this form (if any) indicating that I am
        exempt from FATCA reporting is correct.
      </p>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <p
    className="s71"
    style={{
      paddingTop: "1pt",
      textIndent: "0pt",
      lineHeight: "87%",
      textAlign: "left"
    }}
  >
    Sign Here
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <p className="s68" style={{ textIndent: "0pt", textAlign: "left" }}>
    Signature of
  </p>
  <p className="s68" style={{ textIndent: "0pt", textAlign: "left" }}>
    U.S. person <span className="s69">▶ {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : null}</span>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <p
    className="s68"
    style={{ textIndent: "0pt", lineHeight: "8pt", textAlign: "left" }}
  >
    Date <span className="s69">▶ {props.viewObject !== undefined ? props.viewObject.date1 : props.date}</span>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }} />
  <p
    className="s63"
    style={{
      paddingTop: "3pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Certification instructions.{" "}
    <span className="s67">
      You must cross out item 2 above if you have been notified by the IRS that
      you are currently subject to backup withholding because you have failed to
      report all interest and dividends on your tax return. For real estate
      transactions, item 2 does not apply. For mortgage interest paid,
      acquisition or abandonment of secured property, cancellation of debt,
      contributions to an individual retirement arrangement (IRA), and
      generally, payments other than interest and dividends, you are not
      required to sign the certification, but you must provide your correct TIN.
      See the instructions for Part II, later.
    </span>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s75"
    style={{
      paddingTop: "4pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    General Instructions
  </p>
  <p
    className="s67"
    style={{
      paddingTop: "3pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Section references are to the Internal Revenue Code unless otherwise noted.
  </p>
  <p
    className="s63"
    style={{
      paddingTop: "2pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Future developments
    <a
      href="http://www.irs.gov/FormW9"
      style={{
        color: "black",
        fontFamily: "Arial, sans-serif",
        fontStyle: "normal",
        fontWeight: "normal",
        textDecoration: "none",
        fontSize: "8pt"
      }}
      target="_blank"
    >
      . For the latest information about developments related to Form W-9 and
      its instructions, such as legislation enacted after they were published,
      go to{" "}
    </a>
    <a href="http://www.irs.gov/FormW9" className="s76" target="_blank">
      www.irs.gov/FormW9.
    </a>
  </p>
  <p
    className="s77"
    style={{
      paddingTop: "4pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Purpose of Form
  </p>
  <p
    className="s67"
    style={{
      paddingTop: "3pt",
      paddingLeft: "6pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    An individual or entity (Form W-9 requester) who is required to file an
    information return with the IRS must obtain your correct taxpayer
    identification number (TIN) which may be your social security number (SSN),
    individual taxpayer identification number (ITIN), adoption taxpayer
    identification number (ATIN), or employer identification number (EIN), to
    report on an information return the amount paid to you, or other amount
    reportable on an information return. Examples of information returns
    include, but are not limited to, the following.
  </p>
  <ul id="l9">
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "12pt",
          textIndent: "-6pt",
          textAlign: "left"
        }}
      >
        Form 1099-INT (interest earned or paid)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "5pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Form 1099-DIV (dividends, including those from stocks or mutual funds)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Form 1099-MISC (various types of income, prizes, awards, or gross
        proceeds)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "3pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Form 1099-B (stock or mutual fund sales and certain other transactions
        by brokers)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "12pt",
          textIndent: "-6pt",
          textAlign: "left"
        }}
      >
        Form 1099-S (proceeds from real estate transactions)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "12pt",
          textIndent: "-6pt",
          textAlign: "left"
        }}
      >
        Form 1099-K (merchant card and third party network transactions)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Form 1098 (home mortgage interest), 1098-E (student loan interest),
        1098-T (tuition)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "12pt",
          textIndent: "-6pt",
          textAlign: "left"
        }}
      >
        Form 1099-C (canceled debt)
      </p>
    </li>
    <li data-list-text="•">
      <p
        className="s67"
        style={{
          paddingTop: "2pt",
          paddingLeft: "12pt",
          textIndent: "-6pt",
          textAlign: "left"
        }}
      >
        Form 1099-A (acquisition or abandonment of secured property)
      </p>
    </li>
  </ul>
  <p
    className="s67"
    style={{
      paddingTop: "2pt",
      paddingLeft: "6pt",
      textIndent: "8pt",
      textAlign: "left"
    }}
  >
    Use Form W-9 only if you are a U.S. person (including a resident alien), to
    provide your correct TIN.
  </p>
  <p
    className="s72"
    style={{
      paddingTop: "2pt",
      paddingLeft: "6pt",
      textIndent: "8pt",
      textAlign: "left"
    }}
  >
    If you do not return Form W-9 to the requester with a TIN, you might be
    subject to backup withholding. See{" "}
    <span className="s67">What is backup withholding, </span>later.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    style={{
      paddingLeft: "5pt",
      textIndent: "0pt",
      lineHeight: "1pt",
      textAlign: "left"
    }}
  >
    <span />
  </p>
  <p
    className="s78"
    style={{ paddingLeft: "8pt", textIndent: "0pt", textAlign: "left" }}
  >
    <span className="s59">Cat. No. 10231X </span>Form{" "}
    <span className="s79">W-9 </span>(Rev. 10-2018)
  </p>
  <p
    className="s80"
    style={{
      paddingTop: "3pt",
      paddingLeft: "22pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Emergency Contacts:
  </p>
  <p
    className="s81"
    style={{
      paddingTop: "12pt",
      paddingLeft: "22pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Please provide 2 Relatives or Friends we can or should contact In case of an
    emergency.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s84"
    style={{
      paddingTop: "11pt",
      paddingLeft: "20pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    First and Last Name
    <br/>
    <u>
      X
      {props.viewObject !== undefined ? props.viewObject.emergencyContactName1 : props.emergencyContactName1}
    </u>{" "}
  </p>
  <p
    className="s84"
    style={{
      paddingTop: "11pt",
      paddingLeft: "20pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Phone Number
    <br/>
    <u>
      
    {props.viewObject !== undefined ? props.viewObject.emergencyContactPhone1 : props.emergencyContactPhone1}
    </u>{" "}
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s84"
    style={{
      paddingTop: "11pt",
      paddingLeft: "20pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    First and Last Name
    <br/>
    <u>
      X
      {props.viewObject !== undefined ? props.viewObject.emergencyContactName2 : props.emergencyContactName2}
    </u>{" "}
  </p>
  <p
    className="s84"
    style={{
      paddingTop: "11pt",
      paddingLeft: "20pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Phone Number
    <br/>
    <u>
      
    {props.viewObject !== undefined ? props.viewObject.emergencyContactPhone2 : props.emergencyContactPhone2}
    </u>{" "}
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
</div>

}

export default NewDriverPacketModule;
